import './styles.scss'
import React from 'react'

const Index = (props) => {
  const { onHide, children, className } = props

  return (
    <div className={`panel-help ${className ? className : ''}`}>
      <div className='panel-help-overlay' onClick={onHide} />
      <div className='panel-wrapper'>
        <div className='btn-close' onClick={onHide}>
          <span className='close'> &times; </span>
        </div>

        <div className='panel-help-container'>
          <div className='panel-help-body'>{children}</div>
        </div>
      </div>
    </div>
  )
}

export default Index
